import { render, staticRenderFns } from "./helpPersonVideo.vue?vue&type=template&id=a8dab214&scoped=true&"
import script from "./helpPersonVideo.vue?vue&type=script&lang=js&"
export * from "./helpPersonVideo.vue?vue&type=script&lang=js&"
import style0 from "./helpPersonVideo.vue?vue&type=style&index=0&id=a8dab214&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8dab214",
  null
  
)

export default component.exports